import { defineTemplate } from '../../../utils';
import { PATH_URL } from '../_shared/data/path-url';

const THUMB = `${PATH_URL}/ctv`;

export const hipotecarioCTV = defineTemplate({
  mode: 'legacy',
  id: 'hipotecario-ctv',
  clientId: 'HIPOTECARIO',
  handlerKey: 'HIPOTECARIO',
  title: 'CTV',
  thumbnail: {
    url: `${THUMB}/thumbnails/1920x1080.jpg`,
    aspectRatio: 'horizontal'
  },
  previewByResolution: {
    '1920x1080': { kind: 'video', url: `${THUMB}/1920x1080.mp4` },
    '300x250': { kind: 'video', url: `${THUMB}/300x250.mp4` },
    '300x600': { kind: 'video', url: `${THUMB}/300x600.mp4` },
    '1080x1080': { kind: 'video', url: `${THUMB}/1080x1080.mp4` },
    '1080x1350': { kind: 'video', url: `${THUMB}/1080x1350.mp4` }
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'copy',
      label: 'Copy',
      type: 'input',
      placeholder: '100% digital, con aprobación ágil',
      required: false,
      multiline: true
    },
    {
      key: 'video',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true
    }
  ],
  // Ejemplo que precarga el textarea de prompt (el usuario lo edita antes de enviar).
  // Ajustá el video/copy de ejemplo.
  promptTemplate: `Haceme un video CTV usando este video "https://media-stage.doer.ar/brands/assets/HIPOTECARIO/instagram/DRP1E-BDVbb.mp4"
  con este copy "100% digital, con aprobación ágil"`
});
